var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-boxStyle"},[_vm._l((4),function(num,index){return _c('img',{key:index + 'boxStyle',class:'bg-' + index,attrs:{"src":require("../../../images/bg.png"),"alt":""}})}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }